import { ChangeEvent } from 'react'
import RadioButton from '../RadioButton'
import { RadioGroupOption, RadioGroupProps } from './types'
import * as S from './styles'

const RadioGroup = ({
  name,
  selectedValue,
  onChange,
  direction = 'column',
  options = [],
  style = {},
}: RadioGroupProps) => {
  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onChange({ selectedValue: target.value })
  }

  const isChecked = (item: RadioGroupOption) =>
    Boolean(selectedValue) &&
    selectedValue?.toString() === item.value.toString()

  return (
    <S.RadioGroupWrapper className={direction}>
      {Array.isArray(options) &&
        options.map((item, key) => (
          <S.RadioButtonWrapper key={key} style={style}>
            <RadioButton
              id={item.id || `${name}-${item.value}`}
              name={name}
              label={item.label}
              value={item.value.toString()}
              checked={isChecked(item)}
              onChange={handleChange}
            />
          </S.RadioButtonWrapper>
        ))}
    </S.RadioGroupWrapper>
  )
}

export default RadioGroup
